<template>
<v-app>
    <router-view />
  <notify ref="notify"/>
</v-app>
</template>
<script>
import notify from '@/components/notify'
import store from '@/store'


export default {
  components: {notify},
  methods: {
    syncTailwindDarkClass(isDark) {
      // Tailwind in `new_design` uses `.dark` to activate `dark:*` styles.
      // Root app uses Vuetify's `.theme--dark`, so we mirror to `.dark`.
      const root = document.documentElement
      if (isDark) root.classList.add('dark')
      else root.classList.remove('dark')
    },
    applyThemeFromStore() {
      const savedDark = store.state.darkMode != null ? store.state.darkMode : true
      if (this.$vuetify.theme.isDark !== savedDark) {
        this.$vuetify.theme.isDark = savedDark
      }
      this.syncTailwindDarkClass(savedDark)
    },
  },
  created() {
    // Before first paint (e.g. login): match Vuetify + html.dark to persisted preference (default dark).
    this.applyThemeFromStore()
  },
  mounted() {
    this.$root.notify = this.$refs.notify
    this.applyThemeFromStore()
  },
  computed:{
    darkMode(){
      return store.state.darkMode
    }
  },
  watch: {
    darkMode(val) {
      const isDark = val != null ? val : true
      this.$vuetify.theme.isDark = isDark
      this.syncTailwindDarkClass(isDark)
    },
  },


}
</script>

<style scoped>
 ::v-deep .v-tooltip__content{
  border: 1px solid rgb(3, 147, 168,0.2) !important;
  /* border-color:rgb(3, 147, 168,0.2); */
  border-radius: 6px;
  backdrop-filter: blur(4px) !important;
  box-shadow: 0px 4px 5px 3px rgba(217, 217, 217, 0.6);
  font-family: 'Inter';
  font-size: 12px !important;
  background-color: white;
  color: black;
  opacity: .9;
}

 .theme--dark ::v-deep .v-tooltip__content{
  box-shadow: none;
  background-color: black !important;
  opacity: .8;
  color: white !important;
}



::v-deep .theme--light.v-label {
  color: rgba(0, 0, 0, 0.9) !important;
}

::v-deep .theme--dark.v-label {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>

<style>
:root {
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--v-primary-base, #0393a8) 55%, #9ca3af) #f3f4f6;
}

html.dark,
.theme--dark {
  scrollbar-color: color-mix(in srgb, var(--v-primary-base, #0393a8) 70%, #6b7280) #1f2937;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f3f4f6;
}

::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--v-primary-base, #0393a8) 55%, #9ca3af);
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--v-primary-base, #0393a8);
}

html.dark ::-webkit-scrollbar-track,
.theme--dark ::-webkit-scrollbar-track {
  background: #1f2937;
}

html.dark ::-webkit-scrollbar-thumb,
.theme--dark ::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--v-primary-base, #0393a8) 70%, #6b7280);
}

html.dark ::-webkit-scrollbar-thumb:hover,
.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: var(--v-primary-base, #0393a8);
}
</style>
